import { createContext, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "./local-storage";
import * as api from "./../utils/api";

const AuthContext = createContext(null);

const USER_LOCAL_STORAGE_KEY = process.env.REACT_APP_USER_LOCAL_STORAGE_KEY;

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();

  const [user, setUser] = useLocalStorage(USER_LOCAL_STORAGE_KEY, null);

  const login = async ({ username, password }) => {
    try {
      const { result, error } = await api.post("/authenticate", { username, password });

      if (error) {
        throw new Error(error);
      }

      setUser(result);
      navigate("/");
    } catch (err) {
      throw err;
    }
  };

  const logout = async () => {
    try {
      setUser(null);
      navigate("/", { replace: true });
    } catch (error) {
      throw error;
    }
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
